<!-- Hero Section -->
<section class="maltech-hero py-5">
  <div class="container">
    <div class="row align-items-center">
      <!-- Left: Image -->
      <div class="col-lg-6 col-md-6 col-12 text-center mb-4 mb-md-0">
        <img
          src="/assets/images/development/hero.webp"
          alt="Software development services by MALtech"
          class="img-fluid maltech-hero-image"
          loading="lazy"
        />
      </div>

      <!-- Right: Content -->
      <div class="col-lg-6 col-md-6 col-12">
  <div class="maltech-hero-content text-center text-md-start">
    <div class="maltech-hero-topline mx-auto mx-md-0"></div>
          <h1 class="maltech-hero-title">
            Empowering Businesses with Scalable, Secure and Custom Software
            Solutions
          </h1>
          <p class="maltech-hero-description px-2">
            MALtech is your trusted partner for end-to-end web, mobile, and
            enterprise software solutions. We focus on scalability, security,
            and user experience to deliver lasting value. We transform your
            ideas into robust and intelligent software solutions.
          </p>
          <div
            class="d-flex flex-wrap gap-3 justify-content-center justify-content-md-start"
          >
           <a routerLink="/contact" href="/contact" class="btn maltech-btn"> Work Together </a>

          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Why Choose Section -->
<section class="maltech-why-choose py-2" id="get-start">
  <div class="container">
    <!-- Section Title & Description -->
    <div class="text-center mb-5">
      <h2 class="maltech-section-title">
        Why Choose MALtech for Software Development Services?
      </h2>
      <p class="maltech-section-description px-2">
        MALtech stands as a trusted partner for businesses seeking reliable and
        future-ready software development. We build scalable web, mobile, and
        enterprise applications that adapt to evolving business needs. With a
        strong focus on performance, security, and user experience, our
        solutions are designed to add real value. From design to deployment,
        every step is handled with precision and innovation. At MALtech, you
        gain not just software, but a long-term technology partner committed to
        your growth.
      </p>
    </div>

    <!-- Cards Grid -->
    <div class="row g-4 justify-content-center">
      <!-- Card 1 -->
      <div class="col-lg-4 col-md-6 col-12">
        <div class="card maltech-card gradient1 h-100 text-center p-4 hover-card">
          <i class="bi bi-code card-icon mb-3 d-block mx-auto"></i>
          <h5 class="card-title heading-section-card">Web Application Development</h5>
          <p class="card-description">
            Scalable and responsive web applications using modern frameworks.
          </p>
        </div>
      </div>

      <!-- Card 2 -->
      <div class="col-lg-4 col-md-6 col-12">
        <div class="card maltech-card gradient1 h-100 text-center p-4 hover-card">
          <i class="bi bi-phone card-icon mb-3 d-block mx-auto"></i>
          <h5 class="card-title heading-section-card">Mobile App Development</h5>
          <p class="card-description">
            Native and cross-platform apps with seamless performance.
          </p>
        </div>
      </div>

      <!-- Card 3 -->
      <div class="col-lg-4 col-md-6 col-12">
        <div class="card maltech-card gradient1 h-100 text-center p-4 hover-card">
          <i class="bi bi-building card-icon mb-3 d-block mx-auto"></i>
          <h5 class="card-title heading-section-card">Enterprise Software Solutions</h5>
          <p class="card-description">
            Secure enterprise software tailored to your business needs.
          </p>
        </div>
      </div>

      <!-- Card 4 -->
      <div class="col-lg-4 col-md-6 col-12">
        <div class="card maltech-card gradient1 h-100 text-center p-4 hover-card">
          <i class="bi bi-arrow-left-right card-icon mb-3 d-block mx-auto"></i>
          <h5 class="card-title heading-section-card">API & System Integration</h5>
          <p class="card-description">
            Smooth integration with databases and third-party services.
          </p>
        </div>
      </div>

      <!-- Card 5 -->
      <div class="col-lg-4 col-md-6 col-12">
        <div class="card maltech-card gradient1 h-100 text-center p-4 hover-card">
          <i class="bi bi-palette card-icon mb-3 d-block mx-auto"></i>
          <h5 class="card-title heading-section-card">UI/UX Design & Prototyping</h5>
          <p class="card-description">
            Intuitive, user-friendly interfaces with engaging experiences.
          </p>
        </div>
      </div>

      <!-- Card 6 -->
      <div class="col-lg-4 col-md-6 col-12">
        <div class="card maltech-card gradient1 h-100 text-center p-4 hover-card">
          <i class="bi bi-bug card-icon mb-3 d-block mx-auto"></i>
          <h5 class="card-title heading-section-card">Software Testing & Quality Assurance</h5>
          <p class="card-description">
            Comprehensive testing for reliable and bug-free software.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>


<!-- Technologies we use -->
<!-- Technologies Section -->
<section class="maltech-technologies py-5">
  <div class="container">
    <!-- Section Title & Description -->
    <div class="text-center mb-5">
      <h2 class="maltech-section-title">Technologies We Use</h2>
      <p class="maltech-section-description px-2">
        MALtech leverages cutting-edge frameworks, programming languages, and
        cloud platforms to deliver innovative software solutions. By combining
        modern technologies with industry best practices, we build applications
        that are secure, scalable, and designed to adapt to future business
        needs. Our technology expertise ensures reliability, performance, and
        long-term value for every solution we create.
      </p>
    </div>

    <!-- Cards Grid -->
    <div class="row g-4 justify-content-center">
      <div
        class="col-lg-2 col-md-3 col-4 text-center"
        *ngFor="let card of cards2"
      >
        <div class="maltech-tech-card p-3">
          <img
            [src]="card.icon"
            alt="{{ card.title }}"
            class="img-fluid"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Development Process Section -->
<section class="maltech-development-process py-2">
  <div class="container">
    <h2 class="maltech-section-title text-center mb-4">
      Our Development Process
    </h2>

    <!-- Desktop/Tablet: 3 cards per row -->
    <div class="row g-4 d-none d-md-flex">
      <div class="col-md-4" *ngFor="let card of cards3">
        <div
          class="card maltech-card gradient1 p-4 h-100 d-flex flex-column align-items-center text-center"
        >
          <ng-container
            *ngIf="card.icon.startsWith('assets'); else bootstrapIcon"
          >
            <img
              [src]="card.icon"
              alt="{{ card.title }}"
              class="card-icon mb-3 d-block mx-auto"
              loading="lazy"
            />
          </ng-container>
          <ng-template #bootstrapIcon>
            <i
              [class]="card.icon + ' card-icon mb-3'"
              style="font-size: 2rem"
            ></i>
          </ng-template>
          <h5 class="card-title mb-2 heading-section-card">{{ card.title }}</h5>
          <p class="card-description text-dark">{{ card.description }}</p>
        </div>
      </div>
    </div>

    <!-- Mobile: horizontal scroll -->
    <div class="d-md-none maltech-cards-grid">

      <div
        class="card maltech-card gradient1 flex-shrink-0 p-4 d-flex flex-column align-items-center text-center"
        *ngFor="let card of cards3"
        style="width: 220px"
      >
        <ng-container
          *ngIf="card.icon.startsWith('assets'); else bootstrapIconMobile"
        >
          <img
            [src]="card.icon"
            alt="{{ card.title }}"
            class="card-icon mb-3 d-block mx-auto"
            loading="lazy"
          />
        </ng-container>
        <ng-template #bootstrapIconMobile>
          <i
            [class]="card.icon + ' card-icon mb-3'"
            style="font-size: 2rem"
          ></i>
        </ng-template>
        <h5 class="card-title mb-2 ">{{ card.title }}</h5>
        <p class="card-description">{{ card.description }}</p>
      </div>
    </div>
  </div>
</section>

<!-- Why Choose MALtech Section -->
<section class="maltech-why-section py-5">
  <div class="container">
    <!-- Section Title -->
    <div class="text-center">
      <h2 class="maltech-section-title">Why Choose MALtech?</h2>
    </div>

    <!-- Cards Grid -->
    <div class="row g-4 justify-content-center">
      <div class="col-lg-3 col-md-4 col-sm-6" *ngFor="let card of cards4">
        <div class="maltech-card h-100 text-center p-3">
          <img
            [src]="card.icon"
            alt="{{ card.title }}"
            class="card-image mb-3"
            loading="lazy"
          />
          <h5 class="card-title heading-section-card1">{{ card.title }}</h5>
          <p class="card-description">{{ card.description }}</p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Call to Action Section -->
<section class="maltech-cta mb-5">
  <div class="container">
    <h2 class="maltech-section-title text-center mb-3">Get Started Today</h2>

    <div class="row align-items-center gx-0">
      <!-- Reduced horizontal gutter -->
      <!-- Image Column -->
      <div class="col-lg-5 col-md-6 text-center">
        <img
          src="assets/images/development/sec5.webp"
          alt="Contact MALtech to get started"
          class="img-fluid rounded maltech-cta-image"
          loading="lazy"
        />
      </div>

      <!-- Content Column -->
      <div class="col-lg-7 col-md-6">
        <div class="maltech-cta-content">
          <h3 class="maltech-cta-title mb-3">
            Let's Build the Future Together
          </h3> 
          <p class="maltech-cta-description mb-4 px-2">
            Partner with MALtech to turn your ideas into secure, scalable, and
            future-ready software solutions. We combine cutting-edge technology
            with industry best practices to build software that grows with your
            business. Whether you’re a startup or an enterprise, we align
            closely with your vision to deliver impactful solutions. Let us
            transform your concepts into reality with innovation, reliability,
            and excellence.
          </p>
          <a routerLink="/contact" href="/contact" class="btn btn-brand btn-lg" aria-label="Contact Us"> Contact Us </a>
        </div>
      </div>
    </div>
  </div>
</section>
